import { listenerManager } from '../../modules/services/ordersListenerManager';
import { addDriverWarningNotification } from '../../modules/services/notificationDispatcher';
import { doGet } from '../../modules/DataManager';
import { driverWarningsActions } from '../slices/driverWarningsSlice';
import { stripHistory } from '../../modules/utils/stripHistory';
import { findByIdOrAccountId } from '../../modules/logic/driversLogic';

// Fetch driver warnings
export const fetchDriverWarnings = (id_gestore) => {
  return async (dispatch) => {
    dispatch(driverWarningsActions.fetchRequest());

    try {
      const res = await doGet('/v2/fleet/driver-warnings/get-driver-warnings-by-manager', {
        manager_id: id_gestore,
      });
      const driverwarnings = Array.isArray(res)
        ? res.filter((v) => !v.deleted && String(v.id_gestore) === String(id_gestore))
        : [];

      dispatch(driverWarningsActions.fetchSuccess(driverwarnings));

      return driverwarnings;
    } catch (error) {
      console.error('Error loading driverwarnings:', error);
      dispatch(driverWarningsActions.fetchFailure(error.message));
      throw error;
    }
  };
};

// Start listening for driver warnings changes
export const startDriverWarningsListener = (id_gestore) => {
  return (dispatch, getState) => {
    // Validate id_gestore exists
    if (!id_gestore) {
      console.warn('⚠️ Cannot start driver warnings listener: id_gestore is undefined or null');
      return;
    }

    const state = getState();
    const drivers = state.drivers || [];

    // Stop any existing listener
    listenerManager.stopListening('driverWarnings');

    // Access firebase from window object as it seems to be loaded globally (similar to DataManager)
    const firebase = window.firebase;

    if (firebase) {
      const db = firebase.firestore();

      const query = db
        .collection('driver_warnings')
        .where('deleted', '==', false)
        .where('id_gestore', '==', id_gestore);

      const onSnapshot = (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          const warning = { id: change.doc.id, ...stripHistory(change.doc.data()) };

          // Filter client-side by id_gestore
          if (warning.id_gestore !== id_gestore) {
            return;
          }

          switch (change.type) {
            case 'added':
              dispatch(driverWarningsActions.added(warning));

              // Add to notification center only (no toast for driver warnings)
              if (!getState().driverWarnings?.list?.some((w) => w.id === warning.id)) {
                // Ensure drivers list is populated (might be empty if not loaded yet)
                const currentDrivers = getState().drivers || [];
                const driver = findByIdOrAccountId(currentDrivers, warning.id_driver);
                const driverName = driver
                  ? `${driver.nome || ''} ${driver.cognome || ''}`.trim()
                  : `Driver ${warning.id_driver}`;

                addDriverWarningNotification(warning, driverName);
              }
              break;

            case 'modified':
              dispatch(driverWarningsActions.modified(warning));
              break;

            case 'removed':
              dispatch(driverWarningsActions.removed(warning.id));
              break;

            default:
              // Handle any other case
              break;
          }
        });
      };

      listenerManager.startListening('driverWarnings', query, onSnapshot, dispatch);
    } else {
      console.error('Firebase not found on window object. Cannot start driver warnings listener.');
    }
  };
};

// Stop listening for driver warnings changes
export const stopDriverWarningsListener = () => {
  return () => {
    listenerManager.stopListening('driverWarnings');
  };
};
